import type { AppNotification, BoardCardUpdate } from '$lib/types';

// Display-only compatibility for stored system labels; never rewrite user text.
export function boardUpdateAuthorLabel(update: Pick<BoardCardUpdate, 'author_label' | 'author_name' | 'author_user_id'>): string {
  const label = update.author_label ?? update.author_name;
  return update.author_user_id === null && label === 'Chief of Staff' ? 'Omar' : label;
}

export function notificationDisplayTitle(notification: Pick<AppNotification, 'type' | 'title'>): string {
  if (notification.type === 'board_nudge' && notification.title === 'Chief of Staff') return 'Omar';
  if (notification.type === 'directive' && notification.title === 'New task from Chief of Staff') return 'New task from Omar';
  return notification.title;
}
